import { render, staticRenderFns } from "./PickLabel.vue?vue&type=template&id=d5ec3fd6&scoped=true"
import script from "./PickLabel.vue?vue&type=script&lang=js"
export * from "./PickLabel.vue?vue&type=script&lang=js"
import style0 from "./PickLabel.vue?vue&type=style&index=0&id=d5ec3fd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5ec3fd6",
  null
  
)

export default component.exports